import { List } from "immutable";
import { DefaultStoreDataObject, StoreDataObject } from "../../models/generic";
import { TagAdmin } from "../../models/tag";

export interface AdminTagState {
    tags: StoreDataObject<List<TagAdmin>>;
}

export const initialAdminTagState: AdminTagState = {
    tags: DefaultStoreDataObject(List()),
};



// WEBPACK FOOTER //
// ./src/store/adminTag/AdminTagState.ts